import React from 'react';
import { View } from 'react-native-web';
import {Button, ButtonImage} from "../../../components";
import Colors from "../../../constants/Colors";

const UtilityBar = (props) => {

    const { onEdit, onRemove, onStats, selectButton } = props;

    return (
        <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>

            {
                props.children
            }

            {
                selectButton &&
                    <Button
                        onPress={selectButton.onPress}
                        text={selectButton.text}
                        containerPropsStyle={{ height: 30, marginLeft: 12, marginRight: 12, }}
                        textPropsStyle={{ fontSize: 18 }}
                    />
            }

            {
                onEdit &&
                <ButtonImage
                    onPress={onEdit}
                    imageSource={require('../../../img/icons/icon-pen.png')}
                    imagePropsStyle={{ width: 16, height: 16, tintColor: Colors.fontColorOnBackground, marginRight: 12 }}
                />
            }

            {
                onStats &&
                <ButtonImage
                    onPress={onStats}
                    imageSource={require('../../../img/icons/analytics-outline.png')}
                    imagePropsStyle={{ width: 16, height: 16, tintColor: Colors.fontColorOnBackground, marginRight: 12 }}
                />
            }

            {
                onRemove &&
                <ButtonImage
                    onPress={onRemove}
                    imageSource={require('../../../img/icons/icon-trash.png')}
                    imagePropsStyle={{ width: 16, height: 16, tintColor: Colors.fontColorOnBackground, marginRight: 12 }}
                />
            }


        </View>
    )

}

export default UtilityBar;
